// Thin wrapper around mixpanel-browser.
// Follows the same closure + named-export pattern as server_time.js.
import mixpanel from "mixpanel-browser"

let initialized = false
let isMasquerade = false

function init(token) {
  if (!token || initialized) return

  mixpanel.init(token, {
    track_pageview: false,          // we track manually on turbo:load
    persistence: "localStorage",
    api_host: "https://api-js.mixpanel.com"
  })
  initialized = true
}

function identify(userId, userProps, companyProps, masquerade) {
  isMasquerade = !!masquerade
  if (isMasquerade || !initialized) return

  mixpanel.identify(String(userId))

  mixpanel.people.set({
    $name: userProps.name,
    $email: userProps.email,
    company_id: userProps.company_id,
    company_name: userProps.company_name,
    role: userProps.role,
    plan_type: userProps.plan_type,
    locale: userProps.locale,
    created_at: userProps.created_at
  })

  // Super properties — sent with every event automatically
  mixpanel.register({
    company_id: companyProps.id,
    company_name: companyProps.name,
    user_role: userProps.role,
    platform: "web",
    locale: userProps.locale
  })

  // Group Analytics — enables company-level queries
  mixpanel.set_group("company", String(companyProps.id))
}

function track(event, properties = {}) {
  if (!initialized || isMasquerade) return

  mixpanel.track(event, properties)
}

function trackPageView(pageName, extraProps = {}) {
  track("Page Viewed", {
    page_name: pageName,
    url: window.location.pathname,
    ...extraProps
  })
}

function reset() {
  if (initialized) mixpanel.reset()
  initialized = false
  isMasquerade = false
}

function isInitialized() {
  return initialized
}

export { init, identify, track, trackPageView, reset, isInitialized }
